import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Button from 'components/common/Button/Button'
import Text from 'components/common/Text/Text'
import Link from 'components/common/Link/Link'
import Media from 'components/common/Media'
import PhoneLink from 'components/common/PhoneLink'
import { STORE_LOCATOR_PAGE } from 'constant'
import { formatPhoneNumber } from 'helpers/phone-number'

const EmptyTireLinesList = ({
  handleTiresSearch,
  storePhoneNumber,
  text
}) =>
  <Wrapper data-at-empty-tire-lines-list>
    {
      storePhoneNumber ?
        <Fragment>
          <Media.Desktop>
            <Text data-at-text-with-phone-number>{ text }{ formatPhoneNumber(storePhoneNumber) }</Text>
          </Media.Desktop>
          <Media.Mobile>
            <Text data-at-text-with-phone-number>
              { text }
              <Phone number={ storePhoneNumber } />
            </Text>
          </Media.Mobile>
        </Fragment> :
        <Fragment>
          <Text data-at-text-with-store-link>{ text }<Link to={ STORE_LOCATOR_PAGE }>local store</Link></Text>
          <Text block>OR</Text>
        </Fragment>
    }
    <ButtonWrapper>
      <Button data-at-view-eligible-tires-button onClick={ handleTiresSearch } >View Eligible Tires</Button>
    </ButtonWrapper>
  </Wrapper>

export default EmptyTireLinesList

EmptyTireLinesList.propTypes = {
  handleTiresSearch: PropTypes.func,
  storePhoneNumber: PropTypes.string,
  text: PropTypes.string
}

const Wrapper = styled.div`
  max-width: 558px;
  margin: 0 auto;
  text-align: center;

  & ${Text},
  & ${Link} {
    font-size: 18px;
    font-weight: 600;
    line-height: 22px;
  }
`

const Phone = styled(PhoneLink)`
  font-size: 18px;
  font-weight: 600;
`

const ButtonWrapper = styled.div`
  margin-top: 22px;
`
